import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { DhsResourceDetailsDialog } from 'components/MapPage/CorporateViewTabs/ResourceTab/DhsResourceDetailsDialog';
import type { ResourceRow } from 'components/MapPage/CorporateViewTabs/ResourceTab/ResourceTabCard';

export type HwcgEocAssetSummary = {
  resourceSetId: string;
  name: string;
  address: string;
  kind: string;
  type: string;
  owningOrganization: string;
};

export function hwcgEocAssetForSelectedCompany(
  companies: {
    companyName: string;
    eocLocation: string;
    eocResourceSetId?: string | null;
  }[],
  companyName: string | null | undefined
): HwcgEocAssetSummary | null {
  const company = companyName?.trim().toLowerCase() ?? '';
  if (!company) return null;
  const match = companies.find(
    (row) => row.companyName.trim().toLowerCase() === company
  );
  if (!match?.eocResourceSetId) return null;
  return {
    resourceSetId: match.eocResourceSetId,
    name: `${match.companyName.trim()} EOC`,
    address: match.eocLocation,
    kind: 'Facilities',
    type: 'Emergency Operations Center',
    owningOrganization: match.companyName.trim(),
  };
}

function assetRow(asset: HwcgEocAssetSummary, incidentId: string): ResourceRow {
  return {
    id: asset.resourceSetId,
    resource_set_id: asset.resourceSetId,
    name: asset.name,
    kind: asset.kind,
    type: asset.type,
    address: asset.address,
    owning_organization: asset.owningOrganization,
    symbology: 'emergencyOperationsCenter',
    quantity: 1,
    incidents: incidentId ? [incidentId] : [],
  };
}

/** The responsible party's EOC facility, beside the outcome radios. */
export function HwcgEocAssetCard({
  asset,
  incidentId,
}: {
  asset: HwcgEocAssetSummary;
  incidentId: string;
}) {
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState<'view' | 'edit'>('view');
  const [row, setRow] = useState<ResourceRow>(() =>
    assetRow(asset, incidentId)
  );

  return (
    <div className="tw:flex tw:flex-wrap tw:items-start tw:justify-between tw:gap-3 tw:rounded-md tw:border tw:border-border tw:p-3">
      <div>
        <div className="tw:text-[11px] tw:font-semibold tw:uppercase tw:tracking-wide tw:text-muted-foreground">
          EOC facility
        </div>
        <div className="tw:mt-1 tw:text-sm tw:font-medium">{asset.name}</div>
        <div className="tw:text-sm tw:text-muted-foreground">
          {asset.address || 'No address yet'}
        </div>
      </div>
      <Button
        type="button"
        size="sm"
        variant="outline"
        onClick={() => setOpen(true)}
      >
        View
      </Button>
      <DhsResourceDetailsDialog
        row={row}
        open={open}
        onOpenChange={(next) => {
          setOpen(next);
          if (!next) setMode('view');
        }}
        mode={mode}
        onModeChange={setMode}
        openedInEdit={false}
        groupMembers={[]}
        onRowPatch={(patch) => setRow((current) => ({ ...current, ...patch }))}
      />
    </div>
  );
}
